import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJob.ResetStatusAndDeleteAssociatedPaymentItems.IRequest;
type Response = Api.Core.ClaimJob.ResetStatusAndDeleteAssociatedPaymentItems.IResponse;
type Headers = Api.Core.ClaimJob.ResetStatusAndDeleteAssociatedPaymentItems.IHeaders;
const url = '/api/Claims/ClaimJob/:id/ResetStatusAndDeleteAssociatedPaymentItems';
export default async function claimJobResetStatusAndDeleteAssociatedPaymentItemsApi(
  body: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { id: body.id }, null),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
